import Tracking from "@/types/tracking/tracking"

export default class TrackingState {
  public tracking: Tracking | null = null
}
